import { useDispatch, useSelector } from "react-redux";
import BaseTextField from "../../../../components/ui/BaseTextField";
import {
  updateWorkOrderForm,
  updateWorkOrderFormValidation,
} from "../../../../store/workOrder/workOrderSlice";

const FixedPay = ({ disabled = false }) => {
  const dispatch = useDispatch();
  const payment = useSelector((state) => state.workOrder.payment.pay);

  const workOrderFormValidation = useSelector(
    (state) => state.workOrder.workOrderFormValidation
  );
  const handleChange = (event) => {
    const { name, value } = event.target;
    const parsedValue = parseFloat(value);
    dispatch(
      updateWorkOrderForm({
        step: "payment",
        data: {
          pay: {
            [name]: value,
          },
        },
      })
    );

    if (name === "fixedAmount" && parsedValue > 0) {
      dispatch(
        updateWorkOrderFormValidation({
          fieldName: "fixedAmount",
          data: false,
        })
      );
    }
    if (name === "fixedAmount" && (!value || parsedValue <= 0)) {
      dispatch(
        updateWorkOrderFormValidation({
          fieldName: "fixedAmount",
          data: true,
        })
      );
      dispatch(
        updateWorkOrderFormValidation({
          fieldName: "fixedAmountErrorMsg",
          data: "Fixed Rate is required",
        })
      );
    }
  };

  return (
    <div className="grid grid-cols-2 gap-y-4 mt-3">
      <div className="mr-10">
        <BaseTextField
          disabled={disabled}
          fullWidth
          fullHeight={false}
          label="Total Pay"
          requirement="required"
          labelShrink={false}
          error={workOrderFormValidation.fixedAmount}
          errorMsg={workOrderFormValidation.fixedAmountErrorMsg}
          id="fixedAmount"
          name="fixedAmount"
          value={payment.fixedAmount}
          onChange={handleChange}
          isDefaultField={false}
          type="float"
        />
      </div>
      {/*  <div>
        <BaseTextField
          disabled={disabled}
          fullWidth
          fullHeight={false}
          id="title"
          label="Approximate hours to complete"
          optional={false}
          labelShrink={false}
          // value={formik.values.title}
          // onChange={formik.handleChange}

          isDefaultField={false}
        />
        <p className="mt-2 text-sm text-right">
          Let provider know how long they will be on the site
        </p>
      </div> */}
    </div>
  );
};

export default FixedPay;
